import React, { useState } from "react";
import { useField } from "formik";

const SwitchButtonFormik = ({
  setFieldValue,
  label,
  name,
  isChecked = false,
  isDisabled = false,
  onChange,
}) => {
  const handleChange = (event) => {
    setFieldValue(name, event.target.checked);
    if (onChange) {
      onChange(event.target.checked, setFieldValue);
    }
  };

  return (
    <div
      className={`d-flex align-items-center form-check form-switch accent-color `}
    >
      <input
        className="form-check-input"
        name={name}
        type="checkbox"
        id={`switch-${name}`}
        checked={isChecked}
        onChange={handleChange}
        disabled={isDisabled}
      />
      {label && (
        <label className="form-check-label" htmlFor={`switch-${name}`}>
          {label}
        </label>
      )}
    </div>
  );
};

export default SwitchButtonFormik;
